// JBHK card cart button: swaps the card's button row for a quantity bar, adds via /cart/add.js,
// then lets Dawn's cart drawer re-render (sections cart-drawer + cart-icon-bubble) and open.
// Labels come from data-* attributes on this script tag (sections/jbhk-header.liquid locales).
(function () {
  var t = document.currentScript.dataset;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function cents(text) {
    return Math.round(parseFloat(text.replace(/[^\d,]/g, '').replace(',', '.')) * 100);
  }
  // Keep the shop's money format (e.g. "€6,49") and only swap the number.
  function money(tpl, value) {
    return tpl.replace(/\d[\d.,]*/, (value / 100).toFixed(2).replace('.', ','));
  }

  function add(form, qty, btn, onError) {
    var inDrawer = btn.closest('cart-drawer');
    var body = new FormData(form);
    body.set('quantity', qty);
    body.set('sections', 'cart-drawer,cart-icon-bubble');
    body.set('sections_url', window.location.pathname);
    btn.disabled = true;
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        btn.disabled = false;
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || !drawer.renderContents) return (window.location.href = root + 'cart');
        drawer.classList.remove('is-empty');
        drawer.renderContents(d);
        // Added from inside the open drawer (cart extras): the clicked button is gone, keep focus and the trap in the drawer
        if (inDrawer && window.trapFocus) window.trapFocus(document.getElementById('CartDrawer'), drawer.querySelector('.drawer__inner'));
      })
      .catch(function (err) {
        btn.disabled = false;
        onError((err && (err.description || err.message)) || t.error);
      });
  }

  function close(card) {
    var panel = card.querySelector('.jbhk-qty');
    if (!panel) return;
    panel.remove();
    card.querySelector('.jbhk-pc__cart').focus();
  }

  // Quantity bar over the card's button row: [× / − | n | +][cart + total]. At 1 the left button closes.
  function open(card) {
    if (card.querySelector('.jbhk-qty')) return;
    var price = card.querySelector('[data-price]').textContent.trim();
    var panel = document.createElement('div');
    panel.className = 'jbhk-qty';
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', t.title);
    panel.innerHTML =
      '<div class="jbhk-qty__step">' +
        '<button type="button" data-d="-1" aria-label="' + t.close + '">×</button>' +
        '<output aria-live="polite">1</output>' +
        '<button type="button" data-d="1" aria-label="' + t.more + '">+</button>' +
      '</div>' +
      '<button type="button" class="jbhk-qty__add" data-add aria-label="' + t.add + '" title="' + t.add + '">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 8V6a4 4 0 0 1 8 0v2"/><path d="m9 14 2 2 4-4"/></svg>' +
        '<span class="jbhk-qty__sum" data-unit="' + cents(price) + '">' + price + '</span>' +
      '</button>';
    panel.dataset.tpl = price;
    card.querySelector('.jbhk-pc__btns').append(panel);
    panel.querySelector('[data-add]').focus();
  }

  document.addEventListener('click', function (e) {
    // A click anywhere else closes an open quantity bar.
    document.querySelectorAll('.jbhk-qty').forEach(function (p) {
      if (!p.contains(e.target)) p.remove();
    });
    var btn = e.target.closest('.jbhk-pc__cart, .jbhk-qty button, [data-jbhk-quick]');
    if (!btn || !window.fetch) return;
    e.preventDefault();
    var card = btn.closest('.jbhk-pc');
    // Podium and cart extras have no card: add one piece straight away.
    if (!card) return add(btn.form, 1, btn, function (msg) { window.alert(msg); });
    if (btn.matches('.jbhk-pc__cart')) return open(card);

    var panel = btn.closest('.jbhk-qty');
    var out = panel.querySelector('output');
    if (btn.dataset.d) {
      var n = +out.textContent + +btn.dataset.d;
      if (n < 1) return close(card);
      n = Math.min(99, n);
      out.textContent = n;
      var minus = panel.querySelector('[data-d="-1"]');
      minus.textContent = n === 1 ? '×' : '−';
      minus.setAttribute('aria-label', n === 1 ? t.close : t.less);
      var sum = panel.querySelector('.jbhk-qty__sum');
      sum.textContent = money(panel.dataset.tpl, sum.dataset.unit * n);
      return;
    }
    var ok = true;
    add(card.querySelector('form[data-jbhk-add]'), out.textContent, btn, function (msg) {
      ok = false;
      window.alert(msg);
    }).then(function () {
      if (ok) panel.remove();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = e.target.closest && e.target.closest('.jbhk-qty');
    if (panel) close(panel.closest('.jbhk-pc'));
  });
})();

// Sub-category filter (snippets/jbhk-subcategories.liquid, mode 'chips'): shows and hides the cards already on the page
// by their data-teil keys. No request and no reload per click; "Alle" shows every card again.
document.querySelectorAll('[data-jbhk-filter]').forEach(function (bar) {
  var scope = document.querySelector(bar.dataset.jbhkFilter);
  if (!scope) return;
  var chips = bar.querySelectorAll('[data-teil-chip]');
  var list = bar.querySelector('.jbhk-rail__list');
  var status = bar.querySelector('[data-teil-status]');
  var hash = bar.hasAttribute('data-hash');
  var active = '';

  function apply(key, announce) {
    var cards = scope.querySelectorAll('[data-teil]');
    var counts = { '': cards.length };
    var shown = 0;
    cards.forEach(function (card) {
      var keys = card.dataset.teil.trim().split(/\s+/);
      keys.forEach(function (k) { if (k) counts[k] = (counts[k] || 0) + 1; });
      card.hidden = key !== '' && keys.indexOf(key) < 0;
      if (!card.hidden) shown++;
    });
    active = key;
    chips.forEach(function (chip) {
      var k = chip.dataset.teilChip;
      chip.setAttribute('aria-pressed', k === key);
      chip.querySelector('[data-n]').textContent = counts[k] || 0;
      // A sub-category without cards (e.g. after Dawn's filters) is hidden, unless it is the active one
      chip.parentNode.hidden = !counts[k] && k !== key;
    });
    var empty = scope.querySelector('[data-teil-empty]');
    if (empty) empty.hidden = shown > 0;
    if (announce && status) status.textContent = bar.dataset.status.replace('[n]', shown);
    if (hash && (key || /^#teil-/.test(location.hash))) {
      history.replaceState(history.state, '', location.pathname + location.search + (key ? '#teil-' + key : ''));
    }
    var chip = bar.querySelector('[aria-pressed="true"]');
    if (chip && list.scrollWidth > list.clientWidth) {
      list.scrollLeft += chip.getBoundingClientRect().left - list.getBoundingClientRect().left - (list.clientWidth - chip.offsetWidth) / 2;
    }
  }

  // #teil-<key>, e.g. from the "Ersatzteile" menu; unknown keys show everything
  function fromHash() {
    var m = /^#teil-(.+)$/.exec(location.hash);
    var key = m ? decodeURIComponent(m[1]) : '';
    var known = Array.prototype.some.call(chips, function (chip) { return chip.dataset.teilChip === key; });
    apply(known ? key : '', !!m);
  }

  bar.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-teil-chip]');
    if (chip) apply(chip.dataset.teilChip, true);
  });
  scope.addEventListener('click', function (e) {
    if (!e.target.closest('[data-teil-empty] button')) return;
    apply('', true);
    chips[0].focus();
  });
  // Dawn's facets.js swaps the grid after a filter or sort change: apply the active sub-category to the new cards
  new MutationObserver(function () { apply(active); }).observe(scope, { childList: true });
  if (hash) {
    window.addEventListener('hashchange', fromHash);
    fromHash();
  } else {
    apply('');
  }
});
